<template>
  <div class="main-container">
    <home-nav-bar v-if="$store.getters.isLogin" title="查看溯源">
      <template #left>
        <router-link :to="{name: 'PackingList'}">
          <van-icon name="arrow-left" />
        </router-link>
      </template>
    </home-nav-bar>
    <pick-info :trace-data="pickInfo" class="content-item" product-type="packing" />
    <van-tabs v-model="active">
      <van-tab title="加工环节">
        <div v-if="parPreparedProducts.length" class="process-list">
          <div v-for="i in parPreparedProducts" :key="i.mngId" class="product-list">
            <div class="process-title">
              {{ i.name }}
            </div>
            <process-link :process-link="i.processJson" class="content-item module" />
            <raw-trace :raw-trace="i.rawMaterials.filter(i=>i.flag)" class="content-item module" />
          </div>
        </div>
      </van-tab>
      <van-tab title="权威检测">
        <test-report-list
          v-if="allTestReportList.length"
          :test-report-list="allTestReportList"
          class="content-item module"
          product-type="packing"
        />
      </van-tab>
      <van-tab title="生产企业">
        <div v-show="!radarShow" class="primary">
          <company-data :company-data="companyTraceDate" class="content-item module" />
        </div>
      </van-tab>
      <van-tab title="产地信息">
        <farm-land-data :user-id="userId" class="content-item module" product-type="packing" />
      </van-tab>
    </van-tabs>
    <div class="bottom-fix-box">
      <div class="content wh-flex-between">
        <div class="left-content">
          <div class="percent">
            100%
          </div>
          <div class="annotation">
            资源完整度
          </div>
        </div>
        <div class="right-content">
          <van-button
            v-if="$store.getters.isLogin"
            class="btn"
            native-type="button"
            round
            type="info"
            @click="editTraceSource"
          >
            编辑溯源
          </van-button>
          <van-button class="btn" native-type="button" round type="primary" @click="viewTraceSourceQr">
            查看溯源码
          </van-button>
        </div>
      </div>
    </div>
    <init-two v-if="radarShow" :show.sync="radarShow" :tab-list="tabList" />
    <qr-trace-dialog v-model="traceCodeQrDialogShow" :trance-code="traceCode" state="pack" />
  </div>
</template>

<script>
import api from '@/api'
import HomeNavBar from '@/views/layout/components/HomeNavBar'
import InitTwo from '@/views/productManage/TraceSource/components/InitTwo'
import QrTraceDialog from '@/views/productManage/TraceSource/components/QrTraceDialog'
import FarmLandData from '@/views/productManage/TraceSource/components/FarmLandData'
import PickInfo from '@/views/productManage/TraceSource/components/PickInfo'
import TestReportList from '@/views/productManage/TraceSource/components/TestReportList'
import CompanyData from '@/views/productManage/TraceSource/components/CompanyData'
import ProcessLink from '@/views/productManage/TraceSource/components/ProcessLink'
import RawTrace from '@/views/productManage/TraceSource/components/RawTrace'

export default {
  name: 'TracePacking',
  components: {
    CompanyData,
    TestReportList,
    PickInfo,
    FarmLandData,
    QrTraceDialog,
    InitTwo,
    HomeNavBar,
    ProcessLink,
    RawTrace
  },
  props: {
    // 通过绑定 route.query 传递
    traceCode: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      active: 0,
      tabList: [
        {
          name: '权威检测',
          icon: 'selection',
          secIcon: 'choice',
          iconTxt: '可追溯',
          show: false
        },
        {
          name: '产地信息',
          icon: 'selection',
          secIcon: 'choice',
          iconTxt: '可追溯',
          show: false
        },
        {
          name: '加工环节',
          icon: 'selection',
          secIcon: 'choice',
          iconTxt: '可追溯',
          show: false
        },
        {
          name: '原料追溯',
          icon: 'selection',
          secIcon: 'choice',
          iconTxt: '可追溯',
          show: false
        },
        {
          name: '生产企业',
          icon: 'selection',
          secIcon: 'choice',
          iconTxt: '可追溯',
          show: false
        }
      ],
      radarShow: true,
      traceCodeQrDialogShow: false,
      pickInfo: {},
      farmlandData: {},
      selectedFarmWorkRecords: [],
      allTestReportList: [],
      companyTraceDate: {},
      farmWorkJSON: [],
      processLink: {},
      rawTrace: [],
      userId: undefined,
      parPreparedProducts: []
    }
  },
  watch: {
    traceCode: {
      async handler(newVal) {
        if (newVal) {
          await this.initTranceSource(newVal)
        }
      },
      immediate: true
    }
  },
  created() {
    setTimeout(() => {
      this.radarShow = false
    }, 100) // 最多展示 6s 隐藏雷达追溯动画
  },
  methods: {
    async initTranceSource(traceCode) {
      await api.getPackingTraceByTraceCodeJL({ traceCode }).then(res => {
        this.userId = res.data.userId
        this.pickInfo = res.data
        this.processLink = res.data.processingJson || {}
        this.rawTrace = res.data.rawMaterialsInfo
        this.allTestReportList = res.data.reportInfo || []
        this.companyTraceDate = res.data.companyInfo || []
        this.parPreparedProducts = res.data.parPreparedProducts || []
      })
    },
    editTraceSource() {
      this.$router.push({
        name: 'TracePackingEdit',
        query: {
          traceCode: this.traceCode
        }
      })
    },
    viewTraceSourceQr() {
      this.traceCodeQrDialogShow = true
    }
  }
}
</script>

<style lang='less' scoped>
.main-container {
  background: #f6f5f5;
}
.primary {
  .content-item {
    margin-top: 8px;
    //background: #ffffff;
    &.module {
      padding: 16px;
    }
  }
  .intro {
    padding: 16px;
    font-size: 14px;
  }
}
.bottom-fix-box {
  @height: 64px;
  height: @height; //用于占位
  display: block;
  width: 100%;
  .content {
    z-index: 2;
    height: @height;
    position: fixed;
    letter-spacing: 0.2em;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 20px 10px;
    box-shadow: 0 0 10px 0 #ccc;
    background: #fff;
    .left-content {
      .percent {
        color: #e85f1a;
      }
      .annotation {
        font-size: 12px;
        color: #cccccc;
      }
    }
    .right-content {
      .btn + .btn {
        margin-left: 10px;
      }
    }
  }
}
.product-list {
  padding: 16px;
  margin-top: 8px;
  background: #FFFFFF;
  .content-item {
    margin-top: 0;
    &.module {
      padding: 0;
    }
  }
}
.van-tabs {
  /deep/ .van-tabs__nav {
    background: none;
  }
  /deep/ .van-tab {
    font-size: 14px;
    font-weight: 500;
    color: #404143;
    line-height: 22px;
  }
  /deep/ .van-tab--active {
    font-size: 16px;
    font-weight: 500;
    color: #44B879;
    line-height: 24px;
  }
  /deep/ .van-tabs__line {
    display: none;
  }
}
.process-list {
  margin: 0 12px;
  display: grid;
  grid-row-gap: 12px;
  .product-list {
    background: #FFFFFF;
    box-shadow: 0 2px 12px 0 rgba(192, 203, 197, 0.4);
    border-radius: 8px;
    padding: 12px;
    .process-title {
      font-size: 14px;
      font-weight: bold;
      color: #44B879;
      line-height: 22px;
    }
  }
}
</style>
